import { useInfiniteQueryGetMembershipSubscriptionPreviousAsMember } from "@gymflow/api";
import { cn } from "@gymflow/helpers";
import useGymflowModels from "apps/portal/src/store";
import { useTranslation } from "react-i18next";

import { usePortalRoutes } from "../../../hooks";
import { RouteFeature } from "../../../routes";
import {
  Button,
  InfiniteScrollContainer,
  ShopBagIcon,
  Spinner,
} from "../../atoms";
import { EmptyPage } from "../../atoms/EmptyPage";
import { HostedPagesBackHeader } from "../components/HostedPagesBackHeader";
import useRedirectIfNotAuthenticated from "../useRedirectIfNotAuthenticated";
import { MembershipHistoryItem } from "./components/MembershipHistoryItem";

export const HostedPagesProfileMembershipHistory = () => {
  const { createSiteOrEmbedLink } = usePortalRoutes();

  useRedirectIfNotAuthenticated(
    createSiteOrEmbedLink(
      RouteFeature.SiteBuyMembershipType.replace(":membershipType", "all"),
    ),
  );

  const { t } = useTranslation();
  const { isEmbed } = usePortalRoutes();
  const { api } = useGymflowModels();

  const queryMembershipHistory =
    useInfiniteQueryGetMembershipSubscriptionPreviousAsMember({ api });
  const {
    data: dataPreviousMembership,
    isLoading: isLoadingPreviousMembership,
  } = queryMembershipHistory;
  const listOfPreviousMembership =
    dataPreviousMembership?.pages.flatMap((e) => e.content) || [];

  return (
    <div
      className={cn("track-height flex w-full flex-col overflow-y-auto", {
        "h-fit": isEmbed,
        "h-full": !isEmbed,
      })}
    >
      <HostedPagesBackHeader
        label={t("page.hostedPagesProfileMembershipHistory.header")}
      />
      <InfiniteScrollContainer
        className={cn(
          "flex flex-col items-center bg-gray-50 dark:bg-gray-900 pt-6 px-4",
          {
            "h-fit": isEmbed,
            "h-full": !isEmbed,
          },
        )}
        query={queryMembershipHistory}
      >
        {listOfPreviousMembership?.length > 0 ? (
          listOfPreviousMembership.map((item) => (
            <MembershipHistoryItem key={item.id} itemInfo={item} />
          ))
        ) : isLoadingPreviousMembership ? (
          <Spinner className="size-7" />
        ) : (
          <div className="flex w-full flex-col items-center justify-center pt-10">
            <EmptyPage
              textOverride={t(
                "page.hostedPagesProfileMembershipHistory.emptyPage.title",
              )}
              description={t(
                "page.hostedPagesProfileMembershipHistory.emptyPage.description",
              )}
              action={
                <Button
                  intent="secondary"
                  className="gap-1.5"
                  link={createSiteOrEmbedLink(
                    RouteFeature.SiteBuyMembershipType.replace(
                      ":membershipType",
                      "all",
                    ),
                  )}
                >
                  <ShopBagIcon pathClassName="stroke-gray-0" />
                  {t(
                    "page.hostedPagesProfileMembershipHistory.emptyPage.action",
                  )}
                </Button>
              }
            />
          </div>
        )}
      </InfiniteScrollContainer>
    </div>
  );
};
